import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import ArgonDashboard from './plugins/argon-dashboard'
import axios from 'axios'
import firebase from 'firebase/app'
import Vuex from 'vuex'
import UUID from 'vue-uuid';

Vue.use(UUID);

Vue.prototype.$axios = axios
Vue.config.productionTip = false

let firebaseConfig = {
  apiKey: "AIzaSyBJ_82vPLeaEWZPIIQMT8iIJtsZolRnrBY",
  authDomain: "next-level-studios-fe397.firebaseapp.com",
  databaseURL: "https://next-level-studios-fe397.firebaseio.com",
  projectId: "next-level-studios-fe397",
  storageBucket: "next-level-studios-fe397.appspot.com",
  messagingSenderId: "1081064809602",
  appId: "1:1081064809602:web:ff4fd91dfbe197cc7d409b",
  measurementId: "G-HG560CHSLG"
};
firebase.initializeApp(firebaseConfig);

Vue.use(Vuex)
Vue.use(ArgonDashboard)

let app;

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})
